function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Skeleton, message, Drawer, Descriptions, Tag, Button, Divider, Space, Collapse } from 'antd';
import Common from "../components/includes/Common";
import { Container, Row, Col } from 'react-bootstrap';
import { CardChecklist, ArrowLeftCircleFill, Receipt, PencilFill, UiChecksGrid, PrinterFill, BinocularsFill, FileEarmarkMedical } from 'react-bootstrap-icons';
import { useParams } from "react-router-dom";
import NewConsultation from "../components/forms/NewConsultation";
import NewPrescription from "../components/forms/NewPrescription";
import EditConsultation from "../components/forms/EditConsultation";
import CrDisplay from "../components/CrDisplay";
import Prescriptions from "../components/Prescriptions";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import NewPharmacyPrescription from "../components/forms/NewPharmacyPrescription";
import Moment from "react-moment";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";

var PatientPage = function PatientPage(_ref) {
  var patientId = _ref.patientId;
  var ref = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      patient = _useState2[0],
      setPatient = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isDataLoading = _useState4[0],
      setIsDataLoading = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isCheckDataLoading = _useState6[0],
      setIsCheckDataLoading = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isBilanLoading = _useState8[0],
      setIsBilanLoading = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isCrVivible = _useState10[0],
      setIsCrVisible = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isBilanVisible = _useState12[0],
      setIsBilanVisible = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isCrDisplayVisible = _useState14[0],
      setIsCrDisplayVisible = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isEditCrVisible = _useState16[0],
      setIsEditCrVIsible = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isEmergencyVisible = _useState18[0],
      setIsEmergencyVisible = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      queueData = _useState20[0],
      setQueueData = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      currentCheck = _useState22[0],
      setCurrentCheck = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      currentQueueItem = _useState24[0],
      setCurrentQueueItem = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      dataChanged = _useState26[0],
      setDataChanged = _useState26[1];

  var _useState27 = useState([]),
      _useState28 = _slicedToArray(_useState27, 2),
      medicalCheckHistory = _useState28[0],
      setMedicalCheckHistory = _useState28[1];

  var _useState29 = useState([]),
      _useState30 = _slicedToArray(_useState29, 2),
      prescriptionHistory = _useState30[0],
      setPrescriptionHistory = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      showPp = _useState32[0],
      setShowPp = _useState32[1];

  var _useParams = useParams(),
      pid = _useParams.pid;

  var handleNc = function handleNc() {
    if (currentQueueItem == null || currentQueueItem.status == 1) {
      message.warning({
        content: "Ce patient n'est pas en attente de consultation",
        delay: 4
      });
      return;
    }

    setIsCrVisible(true);
  };

  var handlePrint = function handlePrint() {};

  var newPrescriptionHandler = function newPrescriptionHandler() {
    setIsBilanVisible(false);
    message.success({
      content: "Bilan(s) prescrit(s) avec succès",
      delay: 4
    });
    setDataChanged(true);
  };

  var handleNp = function handleNp(c) {
    setCurrentCheck(c);
    setIsBilanVisible(true);
  };

  var handleNpp = function handleNpp(c) {
    setCurrentCheck(c);
    setShowPp(true);
  };

  var handleEditCr = function handleEditCr(c) {
    setIsEditCrVIsible(true);
    setCurrentCheck(c);
  };

  var handleDisplayCr = function handleDisplayCr(c) {
    setCurrentCheck(c);
    setIsCrDisplayVisible(true);
  };

  var handleCrEdited = function handleCrEdited() {
    setIsEditCrVIsible(false);
    setDataChanged(true);
    message.success({
      content: "Le compte rendu medical à été modifié",
      delay: 4
    });
  };

  useEffect(function () {
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        var dep = response.data.departments.filter(function (d) {
          return d.dcode == 'CON';
        });
        if (dep.length > 0) axios.get(Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "/" + Common.currentUser.id).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
          setCurrentQueueItem(qresponse.data.queueItems.filter(function (q) {
            return q.customer.idnumber == pid;
          })[0]);
        })["catch"](function (error) {
          message.error({
            content: "0 Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {
          setIsDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: '1 Une erreur est survenue 1 ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setDataChanged(false);
    var patId = pid == null ? patientId : pid;
    axios.get(Common.baseApiUrl + "getcustomerbyid/" + patId.toString() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setPatient(response.data.patient);
        document.title = response.data.patient.firstname + " " + response.data.patient.lastname;
        axios.get(Common.baseApiUrl + "getmedicalchecks/" + response.data.patient.id.toString() + "/" + Common.currentUser.id).then(function (mcresponse) {
          if (response.data.status == 200) {
            setPrescriptionHistory([]);
            setMedicalCheckHistory(mcresponse.data.medicalChecks);
            mcresponse.data.medicalChecks.forEach(function (mc) {
              mc.prescriptions.forEach(function (p) {
                setPrescriptionHistory(function (prev) {
                  return [].concat(_toConsumableArray(prev), [{
                    key: p.id,
                    label: /*#__PURE__*/_jsx(Moment, {
                      date: p.created_at,
                      format: "DD/MM/YYYY"
                    }),
                    children: /*#__PURE__*/_jsx(_Fragment, {
                      children: /*#__PURE__*/_jsx("div", {
                        children: p.prescription_items.map(function (item) {
                          return /*#__PURE__*/_jsx("div", {
                            children: item.business_account_medical_item.label
                          });
                        })
                      })
                    })
                  }]);
                });
              });
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenuee " + error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsCheckDataLoading(false);
        });
        /* axios.get(Common.baseApiUrl+"getprescriptionhistory/"+response.data.patient.id.toString()+"/"+Common.currentUser.id)
         .then(mcresponse => { 
             if(response.data.status == 200){
                 setPrescriptionHistory(mcresponse.data.prescriptions); 
             } 
         }).catch(error => {  
             message.error({content: "Une erreur est survenue", delay: 4});
         }).finally(() => { 
             setIsCheckDataLoading(false);  
         });  */
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "3 Une erreur est survenue 3 " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [pid, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), patient != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsxs(Row, {
              children: [pid && /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 4,
                children: /*#__PURE__*/_jsxs(Button, {
                  type: "primary",
                  onClick: function onClick() {
                    history.back();
                  },
                  icon: /*#__PURE__*/_jsx(ArrowLeftCircleFill, {
                    size: 26
                  }),
                  size: "middle",
                  children: [" ", /*#__PURE__*/_jsx("b", {
                    children: " RETOUR"
                  })]
                })
              }), pid && /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 4,
                children: /*#__PURE__*/_jsxs(Button, {
                  type: "primary",
                  onClick: handleNc,
                  icon: /*#__PURE__*/_jsx(CardChecklist, {
                    size: 26
                  }),
                  size: "middle",
                  children: [" ", /*#__PURE__*/_jsx("b", {
                    children: "CONSULTATION"
                  })]
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "user-info",
              children: /*#__PURE__*/_jsxs("div", {
                className: "user-personal-info cool-radius",
                children: [/*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    labelStyle: {
                      fontWeight: 'Bold'
                    },
                    span: 2,
                    contentStyle: {
                      fontWeight: 'Bold'
                    },
                    label: "CODE PATIENT",
                    children: patient.idnumber
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Pr\xE9nom"
                    }),
                    children: patient.firstname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Nom"
                    }),
                    children: patient.lastname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Tel."
                    }),
                    children: patient.mobile.toString().slice(3)
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Genre"
                    }),
                    children: patient.gender == 'F' ? "Femme" : "Homme"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Date de naissance"
                    }),
                    children: patient.birthdate
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Profession"
                    }),
                    children: patient.job
                  })]
                }), patient.company_id == 0 || patient.company == null ? /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("h6", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "PRISE EN CHARGE"
                    })
                  }), /*#__PURE__*/_jsx("span", {
                    children: "Aucune prise en charge"
                  })]
                }) : /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    column: 3,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "PRISE EN CHARGE"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Soci\xE9t\xE9"
                      }),
                      children: patient.company && patient.company.label
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Assurance"
                      }),
                      children: patient.company != null && patient.company.company_id ? /*#__PURE__*/_jsx("span", {
                        children: patient.company.company.label
                      }) : /*#__PURE__*/_jsx("span", {
                        children: "--"
                      })
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Taux"
                      }),
                      children: patient.company && patient.company.rate + "%"
                    })]
                  })
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsxs(Col, {
                lg: 8,
                md: 8,
                children: [/*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "HISTORIQUE CONSULTATIONS"
                  })
                }), /*#__PURE__*/_jsx(Divider, {}), medicalCheckHistory.map(function (m) {
                  return /*#__PURE__*/_jsxs("div", {
                    style: {
                      background: '#FEE8A4'
                    },
                    className: "cool-radius",
                    children: [/*#__PURE__*/_jsxs(Descriptions, {
                      column: 1,
                      title: /*#__PURE__*/_jsxs("b", {
                        children: ["Date : ", new Date(m.created_at).toLocaleDateString("Fr")]
                      }),
                      children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Motif"
                        }),
                        children: [m.reason.substring(0, 255), " ..."]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Traitement ant\xE9rieure"
                        }),
                        children: [m.traitement_anterieur && m.traitement_anterieur.substring(0, 255), " ..."]
                      })]
                    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      wrap: true,
                      children: [/*#__PURE__*/_jsxs(Button, {
                        type: "default",
                        onClick: function onClick() {
                          handleNp(m);
                        },
                        icon: /*#__PURE__*/_jsx(BinocularsFill, {
                          size: 26
                        }),
                        size: "middle",
                        children: [" ", /*#__PURE__*/_jsx("b", {
                          children: " EXAM. COMPLEMENTAIRES"
                        })]
                      }), /*#__PURE__*/_jsxs(Button, {
                        type: "default",
                        onClick: function onClick() {
                          handleNpp(m);
                        },
                        icon: /*#__PURE__*/_jsx(Receipt, {
                          size: 26
                        }),
                        size: "middle",
                        children: [" ", /*#__PURE__*/_jsx("b", {
                          children: " ORDONNACE"
                        })]
                      }), /*#__PURE__*/_jsx(Button, {
                        type: "default",
                        onClick: function onClick() {
                          handleDisplayCr(m);
                        },
                        icon: /*#__PURE__*/_jsx(PrinterFill, {
                          size: 26
                        }),
                        size: "middle"
                      }), /*#__PURE__*/_jsx(Button, {
                        type: "default",
                        onClick: function onClick() {
                          handleEditCr(m);
                        },
                        icon: /*#__PURE__*/_jsx(PencilFill, {
                          size: 26
                        }),
                        size: "middle"
                      })]
                    })]
                  }, m.id);
                })]
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "white-bg",
                  style: {
                    background: '#89B4D7'
                  },
                  children: [/*#__PURE__*/_jsx("h4", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "HISTORIQUE PRESCRIPTIONS"
                    })
                  }), /*#__PURE__*/_jsx(Collapse, {
                    items: prescriptionHistory
                  })]
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          style: {
            color: '#EEE'
          },
          children: "Fiche de compte rendu"
        }),
        width: "97%",
        destroyOnClose: true,
        headerStyle: {
          background: '#464646',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: isCrVivible,
        onClose: function onClose() {
          setIsCrVisible(false);
        },
        children: currentQueueItem && /*#__PURE__*/_jsx(NewConsultation, {
          handler: function handler() {
            setDataChanged(true);
            setIsCrVisible(false);
            message.success({
              content: "Opération reussie",
              delay: ''
            });
          },
          patient: patient,
          queueData: queueData,
          queueId: currentQueueItem.id
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          style: {
            color: '#EEE'
          },
          children: ["EXAMENS COMPLEMENTAIRES POUR LE PATIENT ", patient.firstname + " " + patient.lastname]
        }),
        width: "98%",
        headerStyle: {
          background: '#464646',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: isBilanVisible,
        destroyOnClose: true,
        onClose: function onClose() {
          setIsBilanVisible(false);
        },
        children: patient && /*#__PURE__*/_jsx(Prescriptions, {
          handler: newPrescriptionHandler,
          patient: patient,
          check: currentCheck
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          style: {
            color: '#EEE'
          },
          children: ["PRESCRIPTION DE MEDICAMENTS POUR LE PATIENT ", patient.firstname + " " + patient.lastname]
        }),
        width: "98%",
        headerStyle: {
          background: '#464646',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: showPp,
        destroyOnClose: true,
        onClose: function onClose() {
          setShowPp(false);
        },
        children: patient && /*#__PURE__*/_jsx(NewPharmacyPrescription, {
          patient: patient,
          check: currentCheck,
          handler: function handler() {
            setShowPp(false);
            setDataChanged(true);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          style: {
            color: '#EEE'
          },
          children: "REVOIR LE COMPTE RENDU"
        }),
        width: "98%",
        destroyOnClose: true,
        headerStyle: {
          background: '#464646',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: isEditCrVisible,
        onClose: function onClose() {
          setIsEditCrVIsible(false);
        },
        children: currentCheck && /*#__PURE__*/_jsx(EditConsultation, {
          handler: handleCrEdited,
          check: currentCheck
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          style: {
            color: '#EEE'
          },
          children: "FICHE DE CONSULTATION"
        }),
        width: "98%",
        destroyOnClose: true,
        headerStyle: {
          background: '#464646',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: isCrDisplayVisible,
        onClose: function onClose() {
          setIsCrDisplayVisible(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: currentCheck && /*#__PURE__*/_jsx(CrDisplay, {
          ref: ref,
          check: currentCheck
        })
      })]
    })]
  });
};

export default PatientPage;